import { forwardRef } from 'react';
import MaterialBackdrop, { BackdropProps } from '@mui/material/Backdrop';

export const Backdrop = forwardRef<HTMLDivElement, BackdropProps>(
    (props, ref) => {
        return (
            <MaterialBackdrop
                ref={ref}
                data-testid={'Backdrop-container'}
                {...props}
            />
        );
    }
);

export default Backdrop;
